import { Component, OnInit } from '@angular/core';
import { GoogleTagManagerService } from 'src/app/services/google-tag-manager.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  sacUrl: string | undefined;
  textPhoneOuvidoria: string | undefined;
  textPhoneSac: string | undefined;
  whatsappUrl: string | undefined;
  showDevelopBar = false;


  constructor(private gtmService: GoogleTagManagerService) { }

  ngOnInit(): void {
    this.textPhoneOuvidoria=environment.contacts.textPhoneOuvidoria;
    this.textPhoneSac=environment.contacts.textPhoneSac;
    this.whatsappUrl=environment.contacts.whatsApp;

    this.showDevelopBar = !environment.production;
  }

  async onWhatsAppButtonClick() {
    this.gtmService.push({
      event: 'contactWhatsapp'
    });

    window.open(environment.contacts.whatsApp, '_blank');
  }

  async onPhoneButtonClick() {
    this.gtmService.push({
      event: 'contactSac'
    });
  }

  async onPhoneOuvidoria() {
    this.gtmService.push({
      event: 'contactOuvidoria'
    });
  }

}
